export default __webpack_public_path__ + "static/media/ProductSans-Black.ed8ca4d4.svg";